import css from '../../../utils/css';

const contractTheme: string = css`
  :host {
    --disclaimer-background: var(--widget-background-color);
    --disclaimer-border-color: var(--widget-accent-background-color);
    --disclaimer-divider-color: var(--widget-divider-color);
    --disclaimer-color: var(--widget-text-color);
    --disclaimer-font-family: var(--widget-font-family);
  }

  :host #root > * {
    --mix-of-bg-and-text: color-mix(
      in lch,
      var(--widget-background-color) 90%,
      var(--widget-cta-background-color)
    );
    --mix-of-bg-and-text-2: color-mix(
      in lch,
      var(--widget-background-color) 80%,
      var(--widget-cta-background-color)
    );

    --header-text-color: var(--widget-text-color);
    --odds-grid-vertical-font-family: var(--widget-font-family);

    --odds-grid-border: var(--widget-accent-background-color);
    --odds-grid-border-radius: var(--widget-cta-border-radius, 4px);
    border-radius: var(--widget-border-radius);

    --odds-grid-bg: var(--widget-background-color);

    --odds-button-text: var(--widget-text-color);
    --odds-button-bg: var(--mix-of-bg-and-text);
    --odds-button-hover-bg: var(--mix-of-bg-and-text-2);

    --odds-button-highlight-text: var(--widget-cta-color);
    --odds-button-highlight-bg: var(--widget-cta-background-color);

    [class*='_oddsButton'][class*='_highlight']:hover {
      background-color: var(--widget-cta-hover-color);
    }

    --no-odds-bg: var(--widget-background-color);
    --no-odds-text: var(--widget-text-color);
    --live-indicator-color: red;

    /* font and colour setting via css var is missing for below element */
    [class*='_gridHeader_'] {
      font-family: var(--widget-font-family);
      color: var(--widget-text-color);
    }
  }
`;

export default contractTheme;
